var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","fill":"#EA5265","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.05427 7L7 8.05427L10.9457 12L7 15.9457L8.05427 17L12 13.0543L15.9457 17L17 15.9457L13.0543 12L17 8.05427L15.9457 7L12 10.9457L8.05427 7Z","fill":"white","key":1})]);
}

Cross.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
